var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.998 9.514l-1.522 1.473-2-1.934c-.73.402-1.563.65-2.464.65-2.771 0-5.016-2.173-5.016-4.853 0-2.68 2.245-4.853 5.016-4.853 2.77 0 5.016 2.173 5.016 4.853 0 1.052-.354 2.019-.942 2.814l1.912 1.85zM5.004 1.782c-1.752 0-3.173 1.374-3.173 3.07 0 1.695 1.421 3.069 3.173 3.069 1.753 0 3.173-1.374 3.173-3.069 0-1.696-1.42-3.07-3.173-3.07z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon.4021dd93.svg";
export { ForwardRef as ReactComponent };